/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-children-prop */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { logOut } from 'Screens/Login/actions/Actions';
import { useIntl } from 'react-intl';
import DropdownItem from './UserDropdownItem';
import { DropdownMenu, Hr } from './styled';

const UserDropdown = ({ modals }) => {
  const dispatch = useDispatch();
  const {
    Help, Extras, About, Preferences
  } = modals;

  const intl = useIntl();
  const preferencesLabel = intl.formatMessage({ id: 'user.menu.preferences' });
  const faradayApiLabel = intl.formatMessage({ id: 'user.menu.faraday.api' });
  const helpLabel = intl.formatMessage({ id: 'user.menu.help' });
  const extrasLabel = intl.formatMessage({ id: 'user.menu.extras' });
  const aboutLabel = intl.formatMessage({ id: 'user.menu.about' });
  const logoutLabel = intl.formatMessage({ id: 'user.menu.logout' });

  return (
    <DropdownMenu onClick={ (e) => e.stopPropagation() }>
      <DropdownItem Modal={ Preferences }>{ preferencesLabel }</DropdownItem>
      <Hr className="h-menu-separator m-0" />
      <DropdownItem link="/api-definitions" >{ faradayApiLabel }</DropdownItem>
      <DropdownItem Modal={ Help }>{ helpLabel }</DropdownItem>
      <DropdownItem Modal={ Extras }>{ extrasLabel }</DropdownItem>
      <DropdownItem Modal={ About }>{ aboutLabel }</DropdownItem>
      <DropdownItem action={ () => dispatch(logOut()) }>{ logoutLabel }</DropdownItem>
    </DropdownMenu>
  );
};

UserDropdown.propTypes = {
  modals: PropTypes.shape({
    Extras: PropTypes.object.isRequired,
    Help: PropTypes.object.isRequired,
    About: PropTypes.object.isRequired,
    Preferences: PropTypes.object.isRequired
  }).isRequired
};

export default UserDropdown;
